import type { TFunction } from "i18next";

/**
 * Per-type count text. Identical to today's text when there are no antennas:
 * returns `fallback` (the call site's current text), else the plain total.
 * Only when antenna > 0 uses `common.typeCounts` ("{m} module · {a} antene").
 */
export function formatTypeCounts(
  t: TFunction,
  counts: Record<string, number> | undefined,
  total?: number,
  fallback?: string,
): string {
  const a = counts?.antenna ?? 0;
  const m = counts?.module ?? 0;
  if (a > 0) return t("common.typeCounts", { m, a });
  return fallback ?? String(total ?? m);
}
